import { render, staticRenderFns } from "./EstimatesOldSpecsLocalSidepage.vue?vue&type=template&id=350e50a6&"
import script from "./EstimatesOldSpecsLocalSidepage.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldSpecsLocalSidepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports